<template>
  <section class="bgFotoVerpackungen">
    <div class="row justify-content-center m-1">
      <div class="col-lg-8 text-center headline">
        <h1 class="headline">Verpackungen</h1>
      </div>
    </div>
    <div class="row justify-content-center p-2 m-md-2">
      <div class="col-lg-6 DES bildschirnansicht text-center">
        <h2 class="headline2 p-4 m-md-5">
          Wir stehen für Qualität, Präzision und individuelle Lösungen.
        </h2>
      </div>
    </div>

    <div class="row justify-content-center p-2 m-md-2">
      <div class="col-lg-6 DES bildschirnansicht text-center">
        <h3 class="headline2 p-4 m-md-5">
          Versandverpackungen, Industrieverpackungen, Präsentverpackungen<br />
          <br />
          ESD-Verpackungen, Pharmazie-Verpackungen<br />
        </h3>
      </div>
    </div>
  </section>
  <section>
    <div>
      <div class="row justify-content-center m-0 hellgrauHintergrund">
        <div class="col-lg-8 text-center">
          <h2 class="headline2 mt-5">Flexibel, effizient und passgenau:</h2>
          <h5 class="headline3">
            Ob Standardkarton, Faltkarton oder maßgeschneiderte Lösung.<br />
            Unsere Kartons sind vielseitig einsetzbar und bieten optimalen Schutz für den
            sicheren Versand und die Lagerung Ihrer Produkte. <br />Hierbei können auch Spezialmaterialien mit Parrafinbeschichtung
            oder ESD-Schutz eingesetzt werden.<br />
          </h5>
        </div>
      </div>
    </div>
  </section>
  <section>
    <balkenMitBild />
  </section>

  <stickybarTelMail />
  <stickyPfeil />
</template>

<script>
import balkenMitBild from "../components/balkenMitBildVerpackungen.vue";
import stickyPfeil from "../components/stickyPfeil.vue";
import stickybarTelMail from "../components/stickybarTelMail.vue";

export default {
  name: "ImpressumPage",

  data() {
    return {
      newSite: null,
    };
  },
  components: {
    stickyPfeil,
    stickybarTelMail,
    balkenMitBild,
  },
  methods: {},
  computed: {},
};
</script>

<style scoped></style>
